module.exports = __webpack_public_path__ + "static/media/truck-right.54db1363.svg";